import { observable, action } from "mobx";
import autobind from "autobind-decorator";

// interface IStatus {
// 	components: any;
// 	incidents: [
// 		{
// 			created_at: string,
// 			id: string,
// 			impact: string,
// 			incident_updates: [
// 				{
// 					affected_components: any,
// 					body: string,
// 					custom_tweet: any,
// 					deliver_notifications: boolean,
// 					display_at: string,
// 					id: string,
// 					incident_id: string,
// 					status: string,
// 					updated_at: string,
// 				}
// 			]
// 			monitoring_at: any,
// 			name: string,
// 			page_id: string,
// 			resolved_at: any,
// 			scheduled_for: string,
// 			scheduled_until: string,
// 			shortlink: string,
// 			status: string,
// 			updated_at: string,
// 		}
// 	];
// 	page: any;
// 	scheduled_maintenances: [
// 		{
// 			created_at: string,
// 			id: string,
// 			impact: string,
// 			incident_updates: [
// 				{
// 					affected_components: any,
// 					body: string,
// 					custom_tweet: any,
// 					deliver_notifications: boolean,
// 					display_at: string,
// 					id: string,
// 					incident_id: string,
// 					status: string,
// 					updated_at: string,
// 				}
// 			]
// 			monitoring_at: any,
// 			name: string,
// 			page_id: string,
// 			resolved_at: any,
// 			scheduled_for: string,
// 			scheduled_until: string,
// 			shortlink: string,
// 			status: string,
// 			updated_at: string,
// 		}
// 	];
// 	status: {
// 		description: string,
// 		indicator: string,
// 	};
// }

export class StatusPageStore {
	@observable public status =
	{
		"status": {
			"description": "none",
			"indicator": "none"
		},
		"incidents": [],
		"scheduled_maintenances": []
	};

	@observable public date = new Date();


	constructor() {
		this.updateData();
		setInterval(this.updateData, 300000); //5min
	}

	@autobind
	@action
	private async updateData() {
		let data;
		let json;
		try {
			data = await fetch("https://7183xkjgdkg1.statuspage.io/api/v2/summary.json");
			json = await data.json();

		}catch (err) {
			json = null;
		}
		//json = null;
		this.status = json;
		this.date = new Date();
	}
}



// WEBPACK FOOTER //
// ./src/lib/stores/StatusPageStore.ts